function PisListController(stateService, $uibModal) {
  
  'ngInject';
  const ctrl = this;
  
  ctrl.$onInit = () => {
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    ctrl.sortType = 'id'; 
    ctrl.sortReverse = false; 
  };
  
  ctrl.$onChanges=(changes)=> {
    if (changes.data) {
      ctrl.data = angular.copy(ctrl.data);
    }
    if (changes.modalOptions) {
      ctrl.modalOptions = angular.copy(ctrl.modalOptions);
    }
  };

  ctrl.toggleEditMode = ($event, item)=> {
    $event.preventDefault();
    $event.stopPropagation();
    ctrl.editMode = true;
    ctrl.onToggle({
      $event: {
        editMode: true,
        item: item,
      },
    });
  };

  ctrl.openDeleteModal = ($event, item)=> {
    $event.preventDefault();
    $event.stopPropagation();
    item.options = ctrl.modalOptions;
    let modalInstance = $uibModal.open({
      component: 'deleteModal',
      backdrop: 'static',
      resolve: {
        item: () => {
          return item;
        },
      },
    });

    modalInstance.result.then(
      itemId => {
        // User pressed 'Yes' in the modal.
        ctrl.onDelete({
          $event: {
            itemId: itemId,
          },
        });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
    
  ctrl.setSortType = column => {
    ctrl.sortType = column;
  };

  ctrl.setSortReverse = () => {
    ctrl.sortReverse = !ctrl.sortReverse;
  };
}

angular
  .module('pis-common.module')
  .controller('PisListController', PisListController);